import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { companyProfileInfoForUser } from '../../../../API/Settings/Company Settings/companySettingsAPI';

const PosAggregatePrint = (props) => {
    const { aggregatorReportList, branch } = props;
    const companyProfileData = useSelector(
        (state) => state?.companyProfileSlice?.userValue
    );

    useEffect(() => {
        companyProfileInfoForUser();
    }, [])

    return (
        <div className="print-main-div" style={{ backgroundColor: "white" }}>
            <div className='header-div' style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    <img src={companyProfileData?.companyLogo} alt="" style={{ height: "62px" }} />
                </div>
                <div style={{ textAlignLast: "center" }}>
                    <h1 style={{ fontSize: "medium", margin: "0" }}>Aggregate Report</h1>
                    <p style={{ margin: "0", fontSize: "small" }}>{branch?.branchName}</p>
                </div>
                <div>
                    <h1 style={{ fontSize: "small", margin: "0" }}>companyName</h1>
                    <p style={{ margin: "0", fontSize: "smaller" }}>{companyProfileData?.companyName}</p>
                    <p style={{ margin: "0", fontSize: "smaller" }}>{companyProfileData?.companyAddress}</p>
                    <p style={{ margin: "0", fontSize: "smaller" }}>{companyProfileData?.companyContact}</p>
                </div>
            </div>
            
            <div className="new-global-table-container" style={{ paddingTop: "0 42px" }}>
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Bill No</th>
                            <th>Customer</th>
                            <th>Mobile</th>
                            <th>Delivery Charge</th>
                            <th>Discount</th>
                            <th>Order Amount</th>
                            <th>Paid Amount</th>
                            <th>Balance</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        {aggregatorReportList?.list?.map((group, groupIndex) => (
                            <React.Fragment key={group._id}>
                                {/* Aggregator Header Row */}
                                <tr style={{ backgroundColor: "#aba8a8" }}>
                                    <td colSpan={10} style={{ fontWeight: "bold" }}>
                                        {group.aggregator} {group.count ? `(${group.count})` : ''}
                                    </td>
                                </tr>
                                
                                {/* Items for this aggregator */}
                                {group.list?.map((item, itemIndex) => (
                                    <tr 
                                        key={item._id}
                                        style={{ 
                                            backgroundColor: itemIndex % 2 === 0 ? "white" : "rgb(214 212 212)",
                                            border: "none"
                                        }}
                                    >
                                        <td>{item.date}</td>
                                        <td>{item.orderRef}</td>
                                        <td>{item.customer}</td>
                                        <td>{item.mobile}</td>
                                        <td>{item.deliveryCharge}</td>
                                        <td>{item.discount}</td>
                                        <td>{item.orderAmount}</td>
                                        <td>{item.paidAmount}</td>
                                        <td>{item.balance}</td>
                                        <td>{item.status || "-"}</td>
                                    </tr>
                                ))}
                                
                                {/* Aggregator Footer Row */}
                                <tr style={{ backgroundColor: "#aba8a8" }}>
                                    <td colSpan={4}>Total for {group.aggregator}</td>
                                    <td>{group.deliveryCharge}</td>
                                    <td></td>
                                    <td>{group.orderAmount}</td>
                                    <td>{group.paidAmount}</td>
                                    <td>{group.balance}</td>
                                    <td></td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>

                    {/* Grand Total Row */}
                    <tfoot>
                        <tr style={{ backgroundColor: "#aba8a8" }}>
                            <td colSpan={4}>Grand Total</td>
                            <td>{aggregatorReportList?.totalDeliveryCharge}</td>
                            <td></td>
                            <td>{aggregatorReportList?.totalOrderAmount}</td>
                            <td>{aggregatorReportList?.totalPaidAmount}</td>
                            <td>{aggregatorReportList?.totalOrderAmount - aggregatorReportList?.totalPaidAmount}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    )
}

export default PosAggregatePrint
